<script setup lang="ts">
import {resolveMediaAlt, resolveMediaUrl} from '~/utils/relations'

const route = useRoute()
const {
  public: {baseUrl},
} = useRuntimeConfig()
const {fetch} = useIndustryProjects()

const slug = route.params.industry as string

const {data: result} = await useAsyncData(`industry-projects-${slug}`, () => fetch(slug))

if (!result.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page not found',
  })
}

const {industry, projects} = result.value

// if no industry but single project found
if (!industry && projects.length === 1) {
  const project = projects[0]
  if (project && project.industriesSlugs.length > 0) {
    await navigateTo(`/projects/${project.industriesSlugs[0]}/${project.slug}`, {redirectCode: 301})
  }
}

const pageTitle = industry?.meta?.title || industry?.name || 'Projects'
const pageDescription =
  industry?.meta?.description || (industry?.name ? `Explore our ${industry.name} projects and case studies` : undefined)
const pageImage = industry?.meta?.image

useSeoMeta({
  title: pageTitle,
  description: pageDescription,
  ogUrl: `${baseUrl}/projects/${slug}`,
  ogTitle: industry?.meta?.ogTitle || pageTitle,
  ogDescription: industry?.meta?.ogDescription || pageDescription,
  ogImage: resolveMediaUrl(pageImage),
  ogImageAlt: resolveMediaAlt(pageImage),
})
</script>

<template>
  <Container class="screen-content min-h-screen flex-1 px-0 pb-32">
    <LayoutPageHeader :title="industry?.name || $t('header.nav.projects')" />

    <section v-if="projects.length > 0" class="mt-8 flex flex-col gap-y-4 md:gap-y-20">
      <ProjectPreview
        v-for="(project, index) of projects"
        :key="project.slug"
        :project="project"
        :industry="industry"
        :is-mirrored="index % 2 !== 0"
      />
    </section>
  </Container>
</template>
